module.exports = __webpack_public_path__ + "img/beSolvedNum.5f384a2a.png";